import { LightningIcon, UsersIcon, MoneyIcon } from "@phosphor-icons/react";
import {
  ROUTES_BACKOFFICE,
  ROUTES_LEGACY_BACKOFFICE,
} from "@backoffice/constants";

import type { TFunction } from "i18next";
import type { SidebarRouteItemProps } from "./sidebar.type";

export const getRoutesApp = (t: TFunction): SidebarRouteItemProps[] => [
  {
    title: t("backoffice.sidebarCompaniesLink"),
    path: ROUTES_LEGACY_BACKOFFICE.COMPANIES.fullPath,
    icon: LightningIcon,
    isExternal: true,
  },
  {
    title: t("backoffice.sidebarChargebacksLink"),
    path: ROUTES_LEGACY_BACKOFFICE.CHARGEBACKS.fullPath,
    icon: UsersIcon,
    isExternal: true,
  },
  {
    title: t("backoffice.sidebarTerminalsLink"),
    path: ROUTES_BACKOFFICE.TERMINALS.fullPath,
    icon: MoneyIcon,
    isExternal: true,
  },
];
